import { camelCase } from 'lodash';
import React, { useEffect, useMemo } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import type { StatusCode } from '@swf/core/enums/statusCode';
import useTrackers from '@swf/core/hooks/useTrackers';
import useTranslationValues from '@swf/core/hooks/useTranslationValues';
import { statusKey } from '@swf/core/utils';
import { emailTagTransform } from '@swf/core/utils/emailTagTransformer';

const RESOLVE_REGEX = /\[#@?(.+?)#]/g;
const DOMAIN_REGEX = /[a-z]+\.[a-z]{2,3}$/;

const ServerMessageHandler: React.FC<{ message: string; code?: StatusCode }> = ({
  message,
  code
}) => {
  const values = useTranslationValues();
  const { errorViewed } = useTrackers();

  const html = useMemo(
    () =>
      !RESOLVE_REGEX.test(message)
        ? message
        : message.replace(RESOLVE_REGEX, (match, value) => {
            let key: string;
            let domain: string | null = null;

            const parts = value.split('-');
            if (value.includes(':') || value.includes('?')) {
              key = camelCase(value.split(':'));
            } else {
              const hasDomain = DOMAIN_REGEX.test(value);
              if (hasDomain) {
                domain = parts.splice(-1);
                key = camelCase(parts.concat('Starsdomain'));
              } else if (!value.includes('starsdomain')) {
                parts.splice(-1);
                key = camelCase(parts.concat('Starsdomain'));
              } else {
                key = camelCase(parts);
              }
            }

            const { emailText, emailLink } = emailTagTransform(
              key,
              null,
              domain,
              values.appStarsdomain as string
            );
            if (emailText) {
              return emailText;
            }
            if (emailLink) {
              return renderToStaticMarkup(emailLink);
            }

            return values[key] as string;
          }),
    [values, message]
  );

  useEffect(() => {
    code && errorViewed({ errorCode: statusKey(code) });
  }, [errorViewed, code]);

  return <span dangerouslySetInnerHTML={{ __html: html }} />;
};

export default ServerMessageHandler;
